/**
 * @file Date input type - extends String with date formatting and input type
 * @version 1.0.0
 */

import { StringInputType } from './string.js';

export const DateInputType = {
  name: 'date',
  matches: getAttribute => getAttribute('format') === 'date',
  displayComponent: {
    name: 'DateDisplay',
    extends: StringInputType.displayComponent,
    methods: {
      formatDisplayValue(value) {
        if (!value) return '';
        const date = new Date(value);
        return date.toLocaleDateString();
      },
    },
  },
  editComponent: {
    name: 'DateEdit',
    extends: StringInputType.editComponent,
    methods: {
      getInputType() {
        return 'date';
      },
    },
  },
};

export default DateInputType;
